import { atomFamily, atomWithStorage } from 'jotai/utils'

/**
 * 配送依頼ドロワーの「配車済みを表示しない」設定（#4488 VOC_PJ-948）
 *
 * 既定は false（配車済みも表示する）。ユーザー単位で localStorage に永続化し、
 * リロード・再ログインでも維持する。別 PC・別ブラウザでは既定から始まる。
 *
 * atomWithStorage + atomFamily の構成は #4609 の drawerShipmentOrderSortAtomFamily
 * （drawer-shipment-order-sort.atom.ts）に揃える。
 * getOnInit: true が要る理由も同じ — false だとマウントまで既定値のままで、
 * 保存値が効く前に既定条件（配車済みを含む）で 1 回問い合わせが走ってしまう
 */
const getDrawerHideDispatchedStorageKey = (userId: number) =>
  `dispatch-board-drawer-hide-dispatched:${String(userId)}`

type Params = { userId: number }

export const drawerHideDispatchedShipmentOrdersAtomFamily = atomFamily(
  (params: Params) =>
    atomWithStorage<boolean>(
      getDrawerHideDispatchedStorageKey(params.userId),
      false,
      undefined,
      { getOnInit: true }
    ),
  (a, b) => a.userId === b.userId
)
